export const STATE_NAME = 'transactionsHistory';
export const prevTransactionInfoDismissed = 'prevTransactionInfoDismissed';
